import { useContext, useState } from 'react'

import AppContext from '@/context/AppContext'

import { isConsentRequired } from './helpers'

const useConsentModal = placement => {
  const { context, setContext } = useContext(AppContext)
  const [showConsentModal, setShowConsentModal] = useState(false)

  const askForConsent = () => {
    if (!isConsentRequired({ context, placement })) return false

    setShowConsentModal(true)

    return true
  }

  const confirmConsent = () => {
    setContext(context => ({ ...context, consentModalAccepted: true }))
    setShowConsentModal(false)
  }

  const closeConsentModal = () => setShowConsentModal(false)

  return {
    consentModal: context.consentModal,
    showConsentModal,
    askForConsent,
    confirmConsent,
    closeConsentModal,
  }
}

export default useConsentModal
